import styled from 'styled-components';
import { color, fontFamily, fontSize, fontWeight, space, textAlign } from 'styled-system';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { ThemeInterface } from '../theme/ThemeInterface';

const H2 = styled.h2<StyledSystemProps>`
  ${space};
  ${color};
  ${fontSize};
  ${textAlign};
  ${fontFamily};
  ${fontWeight};
  text-transform: ${(props: ThemeInterface) => props.textTransform || 'none'};
`;

export default H2;

H2.defaultProps = {
  fontSize: 3,
  m: 0,
};
